export default __webpack_public_path__ + "static/media/Reload.bccb975e.svg";